'use client';
import Gift from '@/app/_components/ui/icons/Gift.svg';
import { useProductContext } from '@/app/_providers/ProductContext';
import PriceUnit from '../share/PriceUnit';
import Image from 'next/image';
import GiftPrice from '../share/giftPrice.jsx';

export default function ProductGift() {
  const { currentVariation } = useProductContext();

  return currentVariation?.gift_price ? (
    <div className="flex  py-3 px-2 md:px-4 rounded-md items-center md:gap-4 gap-2 shadow-[0px_0px_3px_#f176037a] mt-4 border border-canceled-medium">
      <div className="flex flex-col items-center">
        <div className="giftIcon">
          <Gift />
        </div>
      </div>
      <div className="flex-1">
        <div className="flex items-center justify-between">
          <div className="text-canceled-heavy text-sm font-semibold  gift-title">
            هدیه ویژه رایگان
          </div>
          <div className="text-xs flex">
            <span className="text-gray-400 font-semibold"> به ارزش</span>

            <div className="flex mr-1 font-semibold">
              <PriceUnit price={currentVariation.gift_price.sale} />
            </div>
          </div>
        </div>

        <div className="flex justify-between gap-2 items-center">
          <div className="text-xs text-gray-600 mt-1.5 ">
            {currentVariation.gift_price.product.title}
          </div>
        </div>
      </div>
      <div className="overflow-hidden border border-light-gray-200 rounded-md">
        <Image
          src={currentVariation.gift_price.product.media.thumb.full_path}
          width={60}
          height={60}
          alt={currentVariation.gift_price.product.title || 'Gift'}
        />
      </div>
    </div>
  ) : null;
}
